<template>
    <a-modal
        :width="'45%'"
        v-model="resetPassword"
        :title="$t('global.resetPassword')"
        :maskClosable="maskClosable"
        @ok="handleOk">
        <div style="padding:20px;">
            <a-card>
                <a-form :form="resetPasswordForm">
                    <a-form-item :label="$t('global.newPassword')" v-bind="formItemLayout">
                        <a-input type="password" size="small" v-model="newpassword"  v-decorator="[
                              'newPassword',
                              {
                                rules: [{
                                  required: true, message: $t('global.newPasswordTip'),
                                }]
                              }
                            ]"></a-input>
                    </a-form-item>

                    <a-form-item :label="$t('global.confirmPassword')" v-bind="formItemLayout">
                        <a-input type="password" size="small" v-model="confirmPassword" v-decorator="[
                              'confirmPassword',
                              {
                                rules: [{
                                  required: true, message: $t('global.confirmPasswordTip'),
                                },{
                                  validator: checkConfirmPassword,
                                }]
                              }
                            ]"></a-input>
                    </a-form-item>
                </a-form>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    export default {
        name: 'ZResetPassword',
        data() {
            return {
                resetPassword: false,
                resetPasswordForm: null,
                newpassword: null,
                confirmPassword: null,
                userId: null,
                maskClosable: false,
                formItemLayout: {
                    labelCol: {
                        xs: {
                            span: 18
                        },
                        sm: {
                            span: 6
                        },
                    },
                    wrapperCol: {
                        xs: {
                            span: 24
                        },
                        sm: {
                            span: 16
                        },
                    }
                }
            }
        },
        methods: {
            checkConfirmPassword  (rule, value, callback) {
                if (this.newpassword != this.confirmPassword) {
                    callback(this.$t('global.confirmError'))
                }
                callback();
            },
            handleOk(){
                let _this = this
                this.resetPasswordForm.validateFieldsAndScroll((err, values) => {
                    if (!err) {
                        this.$http.post(config.api.url_reset_password + '/' + _this.userId,{"password": _this.newpassword}).then((response) => {
                            if (response.code == 0) {
                                this.resetPassword = false
                                // this.$message.success('密码重置成功')
                                this.$notification.success({
                                  message: this.$t('global.resetPasswordSuccess')
                                })
                            } else {
                                this.$notification.error({
                                  message: response.desc
                                })
                            }
                        })
                    }
                })
            },
            showModel(userId){
                this.userId = userId
                this.resetPassword = true
                this.resetPasswordForm = this.$form.createForm(this)
            }
        }
    }
</script>